import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import type { Authority } from 'Services/common/Features/Authority/types'
import { isSuperuser, type UserShape } from 'Services/common/Features/User/userSlice'
import {
  GLOBAL_SECTION_PATHS,
  IS_WALTTI_SERVICE_ENVIRONMENT,
  SALES_MANAGEMENT_ROOT_URL
} from 'Util/constants'
import type { Location } from 'react-router-dom'

const isPtaSelectionVisible = (user: UserShape | null, location: Location) => {
  // Check if url path contains sales-management
  const isSalesManagement = location.pathname.includes(SALES_MANAGEMENT_ROOT_URL)

  /**
   * The service environment is WALTTI and
   * the user is superuser and
   * the current path is not sales-management
   */
  return IS_WALTTI_SERVICE_ENVIRONMENT && isSuperuser(user) && !isSalesManagement
}

const isGlobalSection = (location: Location) => {
  return GLOBAL_SECTION_PATHS.some(path => location.pathname.includes(path))
}

const useIsPtaBannerVisible = (user: UserShape | null, location: Location) => {
  const { selectedAuthorityCode } = useAuthorityContext()
  return (
    isPtaSelectionVisible(user, location) &&
    (selectedAuthorityCode !== undefined || isGlobalSection(location)) &&
    selectedAuthorityCode !== user?.pta
  )
}

const addEmptyAuthorityOptionForSuperusers = (user: UserShape | null, options: Authority[]) => {
  if (isSuperuser(user)) {
    return [{ id: '', code: '', name: '---------' }, ...options]
  }

  return options
}

export {
  addEmptyAuthorityOptionForSuperusers,
  isGlobalSection,
  isPtaSelectionVisible,
  useIsPtaBannerVisible
}
